import React from 'react';

const AD_IMAGE_URL = 'https://customer-assets.emergentagent.com/job_compliance-hub-623/artifacts/2goenckj_image.png';

export const AdBanner = () => {
  return (
    <div className="w-full border-t border-border bg-background" data-testid="ad-banner">
      <a 
        href="https://www.vantagefleet.co.uk" 
        target="_blank" 
        rel="noopener noreferrer"
        className="block"
      >
        <img 
          src={AD_IMAGE_URL} 
          alt="Vantage Fleet & Compliance - External Transport Management" 
          className="w-full max-w-5xl mx-auto"
        />
      </a>
    </div>
  );
};
